import { render, staticRenderFns } from "./ReportIssueList.vue?vue&type=template&id=35a4223a&scoped=true&"
import script from "./ReportIssueList.vue?vue&type=script&lang=js&"
export * from "./ReportIssueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4223a",
  null
  
)

export default component.exports